<template>
  <v-container>
    <app-navigation></app-navigation>
    <v-main class="pt-12">
      <div class="pt-md-5">
        <v-layout row wrap justify-center align-center>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <main-sub-page-toolbar icon="mdi-palette">{{
              $t("dashboardCardSuperAdminColors")
            }}</main-sub-page-toolbar>
          </v-flex>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <v-card
              class="#505050--text mb-1"
              :class="
                getTheme() == 'dark'
                  ? 'outlined elevation-0'
                  : 'flat elevation-0'
              "
              :style="
                getTheme() == 'dark'
                  ? 'border: 1px solid darkgray; background-color: white'
                  : 'border: none; background-color: white'
              "
            >
              <v-card-text>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-select
                      item-text="theme"
                      item-value="type"
                      :items="themeSelect"
                      v-model="themeType"
                      :label="$t('settingsOtherThemeTitle')"
                    ></v-select>
                    <v-tabs v-model="active">
                      <v-tab v-for="(n, i) in colors" :key="i" ripple>{{
                        n.title
                      }}</v-tab>
                      <v-tab-item v-for="(n, i) in colors" :key="i">
                        <v-card flat class="pa-5">
                          <v-color-picker
                            flat
                            :hide-mode-switch="true"
                            mode="hexa"
                            v-model="n.color"
                          ></v-color-picker>
                        </v-card>
                      </v-tab-item>
                    </v-tabs>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
          <!-- GUMB NAZAJ -->
          <simple-navigation-button
            left
            :title="$t('lmBtnBack')"
            icon="mdi-arrow-left"
            @clicked="$router.push({ name: 'settingsSubMenu' })"
          ></simple-navigation-button>
          <!-- GUMB SHRANI -->
          <simple-navigation-button
            :title="$t('addEditFormSaveButton')"
            icon="mdi-content-save"
            @clicked="savePrimaryColor"
            right
          ></simple-navigation-button>
          <v-snackbar
            v-model="$store.state.storeSnackbar.snackbar.active"
            :color="$store.state.storeSnackbar.snackbar.color"
            :timeout="$store.state.storeSnackbar.snackbar.timeout"
            >{{ $store.state.storeSnackbar.snackbar.message }}</v-snackbar
          >
        </v-layout>
      </div>
    </v-main>
  </v-container>
</template>

<script>
import AppNavigation from "@/views/AppNavigation";
import MainSubPageToolbar from "@/components/MainSubPageToolbar";
import SimpleNavigationButton from "@/components/SimpleNavigationButton";

export default {
  name: "settingsColors",
  components: {
    AppNavigation,
    MainSubPageToolbar,
    SimpleNavigationButton,
  },
  data() {
    return {
      netBackImage: require("@/assets/netBack.png"),
      colors: [
        {
          title: this.$t("settingsDeliveryPrimaryColorTitle"),
          color: "#000000",
        },
        {
          title: this.$t("settingsDeliverySecondaryColorTitle"),
          color: "#000000",
        },
        {
          title: this.$t("settingsDeliveryAccentColorTitle"),
          color: "#000000",
        },
      ],
      themeType: "light",
      active: null,
    };
  },
  methods: {
    async savePrimaryColor() {
      if (this.colors[0].color.hex)
        this.colors[0].color = this.colors[0].color.hex;
      if (this.colors[1].color.hex)
        this.colors[1].color = this.colors[1].color.hex;
      if (this.colors[2].color.hex)
        this.colors[2].color = this.colors[2].color.hex;

      try {
        await this.$store.dispatch("saveSettingsColors", {
          visualSettings: {
            themeColor: {
              primaryColor: this.colors[0].color,
              secondaryColor: this.colors[1].color,
              accentColor: this.colors[2].color,
              type: this.themeType,
            },
          },
        });
      } catch (error) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
        return;
      }
      this.$store.commit({
        type: "showSnackbar",
        color: "success",
        message: this.$t("msgSuccessSaveRefresh"),
      });
    },
  },
  mounted() {
    this.colors[0].color = this.$store.state.storeClient.client.visualSettings.themeColor.primaryColor;
    this.colors[1].color = this.$store.state.storeClient.client.visualSettings.themeColor.secondaryColor;
    this.colors[2].color = this.$store.state.storeClient.client.visualSettings.themeColor.accentColor;
    this.themeType = this.$store.state.storeClient.client.visualSettings.themeColor.type;
  },
};
</script>